import { Component, HostListener } from '@angular/core';
import { EventService } from 'src/app/services/event.service';

@Component({
  selector: 'app-about-app',
  templateUrl: './about-app.component.html',
  styleUrls: ['./about-app.component.scss']
})
export class AboutAppComponent {
  lang: any = localStorage.getItem('currentlang');
  constructor(private eventService: EventService) {
    this.eventService.getLang().subscribe((val) => {
      this.lang = val || 'en';
    });
   }


items= [
  {
    icon :"/assets/images/new/secure-icon.svg",
    head : "about_head1",
    para : "about_para1"

  },
  {
    icon :"/assets/images/new/chain-icon.svg",
    head : "about_head2",
    para : "about_para2"
  },
  {
    icon :"/assets/images/new/key-icon.svg",
    head : "about_head3",
    para : "about_para3"
  },
]

langs(){
  let langlist = ['de','sk','pl','ru','bg','fr'];
  return langlist.includes(this.lang);
}

  // @HostListener('window:scroll', ['$event'])
  // checkScroll() {
  //   const halfScreen = window.innerHeight / 2;
  //   const elements = document.querySelectorAll('.buy-box');
  //   elements.forEach((item: any, i) => {
  //     const rect = item.getBoundingClientRect();
  //     const topPos = rect.top;
  //     if (topPos - 100 < halfScreen) {
  //       item.classList.add('active');
  //     } else {
  //       item.classList.remove('active');
  //     }
  //   })
  // }

}
